import mermaid from "mermaid";

// Renders mermaid diagrams inside the artifact preview. The server emits, per
// diagram, a `[data-mermaid]` container carrying the source in a
// `data-mermaid-src` attribute (HEEx escapes attribute values, and `dataset`
// reads them back decoded) plus empty target / error nodes. We render each
// un-rendered diagram into its target and mark it done so re-runs are
// idempotent.
//
// The preview container's DOM id is content-keyed, so when the file or view
// changes LiveView replaces the node and `mounted()` runs fresh.
export const MermaidRender = {
  mounted() {
    this.renderAll();
  },
  updated() {
    this.renderAll();
  },
  async renderAll() {
    const dark = document.documentElement.classList.contains("dark");

    mermaid.initialize({
      startOnLoad: false,
      securityLevel: "strict",
      theme: dark ? "dark" : "default",
    });

    const pending = this.el.querySelectorAll("[data-mermaid]:not([data-mermaid-done])");

    for (const el of pending) {
      const source = el.getAttribute("data-mermaid-src") ?? "";
      const target = el.querySelector("[data-mermaid-target]");
      const error = el.querySelector("[data-mermaid-error]");

      try {
        const id = `mermaid-svg-${Math.random().toString(36).slice(2)}`;
        const { svg } = await mermaid.render(id, source);
        if (target) target.innerHTML = svg;
        if (error) error.classList.add("hidden");
        el.dataset.mermaidDone = "1";
      } catch {
        if (target) target.innerHTML = "";
        if (error) error.classList.remove("hidden");
        el.dataset.mermaidDone = "1";
      }
    }
  },
};
